export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600 mb-4">
              &bull; Community Trusted
            </p>
            <blockquote className="text-2xl md:text-3xl font-heading font-medium text-foreground-900 leading-relaxed mb-6">
              &ldquo;The Kakobuy Spreadsheet completely changed how I discover products online. Instead of endless scrolling, I can browse organized categories and find exactly what I want in minutes. It is the most efficient shopping tool I have ever used.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <span className="text-sm font-semibold text-foreground-900">Sarah Mitchell</span>
              <span className="flex items-center gap-1">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <i className="ri-star-fill text-accent-500 text-xs"></i>
              </span>
              <span className="text-xs text-foreground-500">Verified Shopper</span>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20a%20stylish%20woman%20with%20warm%20smile%2C%20clean%20cream%20background%2C%20natural%20soft%20lighting%2C%20editorial%20fashion%20portrait%20style%2C%20minimal%20aesthetic%2C%20modern%20lifestyle%20photography%2C%20neutral%20earth%20tones%2C%20professional%20headshot%2C%20high%20quality%20detail&width=700&height=900&seq=testimonial-portrait-01&orientation=portrait"
              alt="Community verified Kakobuy Spreadsheet user testimonial"
              title="Kakobuy Spreadsheet Community Review"
              className="w-full h-auto rounded-2xl object-cover grayscale"
            />
          </div>
        </div>
      </div>
    </section>
  );
}